// should be kept in sync with ppn marketplace data
// https://github.com/porsche-customer/slsystem-ppn-service/blob/master/ppnMarketplaceData/stages/prod.ts
export const allMarketplaceKeys = [
	"am", // Armenia
	"ar", // Argentina
	"at", // Austria
	"au", // Australia
	"az", // Azerbaijan
	"ba", // Bosnia and Herzegovina
	"be", // Belgium
	"bg", // Bulgaria
	"bh", // Bahrain
	"bn", // Brunei
	"bo", // Bolivia
	"br", // Brazil
	"ca", // Canada
	"ch", // Switzerland
	"cl", // Chile
	"cn", // China
	"co", // Colombia
	"cr", // Costa Rica
	"cw", // Curaçao
	"cy", // Cyprus
	"cz", // Czech Republic
	"de", // Germany
	"dk", // Denmark
	"do", // Dominican Republic
	"ec", // Ecuador
	"ee", // Estonia
	"eg", // Egypt
	"es", // Spain
	"fi", // Finland
	"fr", // France
	"gb", // Great Britain
	"ge", // Georgia
	"gp", // French Guadeloupe
	"gr", // Greece
	"gt", // Guatemala
	"hk", // Hong Kong
	"hn", // Honduras
	"hr", // Croatia
	"hu", // Hungary
	"id", // Indonesia
	"ie", // Ireland
	"il", // Israel
	"in", // India
	"is", // Iceland
	"it", // Italy
	"jm", // Jamaica
	"jo", // Jordan
	"jp", // Japan
	"kh", // Cambodia
	"kr", // South Korea
	"kw", // Kuwait
	"kz", // Kazakhstan
	"lb", // Lebanon
	"lk", // Sri Lanka
	"lt", // Lithuania
	"lu", // Luxembourg
	"lv", // Latvia
	"ma", // Morocco
	"md", // Moldova
	"mk", // Macedonia
	"mn", // Mongolia
	"mt", // Malta
	"mu", // Mauritius
	"mx", // Mexico
	"my", // Malaysia
	"nc", // New Caledonia
	"nl", // Netherlands
	"no", // Norway
	"nz", // New Zealand
	"om", // Oman
	"pa", // Panama
	"pe", // Peru
	"pf", // French Polynesia
	"ph", // Philippines
	"pl", // Poland
	"pr", // Puerto Rico
	"pt", // Portugal
	"py", // Paraguay
	"qa", // Qatar
	"re", // French Réunion
	"ro", // Romania
	"rs", // Serbia
	"sa", // Saudi Arabia
	"sg", // Singapore
	"si", // Slovenia
	"sk", // Slovakia
	"sv", // El Salvador
	"th", // Thailand
	"tn", // Tunisia
	"tr", // Turkey
	"tt", // Trinidad and Tobago
	"tw", // Taiwan
	"ua", // Ukraine
	"us", // United States
	"uy", // Uruguay
	"uz", // Uzbekistan
	"vn", // Vietnam
	"xa", // Abu Dhabi
	"xd", // Dubai
	"xp", // Porsche Werkswagen
	"za", // South Africa
] as const

export type MarketplaceKey = (typeof allMarketplaceKeys)[number]
